export default __webpack_public_path__ + "static/media/circle-shark.68eaacbb.png";